<template>
  <div class="results">
    <section class="headtop">
      <div class="container">
        <div class="col-sm-9 right-border">
          <h1>Background information</h1>
        </div>
      </div>
    </section>
    <div class="bottom-widget">
      <div class="container">
        <div class="row">
          <div class="col-md-3 column">
            <p>
              As mentioned on the previous page, MCSim simulates a fictional region which shares many of the characteristics/features of the Midlands but is not a direct representation of the Midlands.
            </p>
            <p>
              As such, the MCSim study area simulates a region which has 11 Urban Settlements, with a Total Population of 7.8 million ( 3.8 million in Urban areas, and the remaining 4.0 million to be found in Rural areas).
            </p>
            <p>
              The Total number of Jobs to be found within the region for 2020 is 2.6 million. Mode shares for the MCSim region begin at 75%% for private car, 13% for public transport modes and 12% for active modes.
            </p>
            <p>
              A graphical representation of the MCSim region can be found in the map on the right.
            </p>
          </div>
          <div class="col-md-9 column">
            <img
              src="/static/img/udm/Generic_Region-01.png"
              class="map"
            >
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-widget">
      <div class="container">
        <div class="pull-right">
          <button
            class="btn btn-primary"
            @click="chooseScenario()"
          >
            Continue
          </button>
        </div>
        <div class="clearfix" />
      </div>
    </div>
  </div>
</template>

<script>
import data from "../services/data";
import router from "../router";

export default {
  data() {
    return {
      sharedStorage: this.$root.$data.sharedStorage,
      scenarios: data.scenarios,
      currentRun: this.$root.$data.sharedStorage.getCurrentRun()
    };
  },
  methods: {
    chooseScenario() {
      const currentRun = this.sharedStorage.getCurrentRun();
      currentRun.setScenario(this.scenarios[0]);

      router.push({ path: "/interventions" });
    }
  }
};
</script>

<style lang="scss">
.gray-widget-box {
  padding: 30px 20px;
}
.gray-widget-box.selected {
  text-align: left;
  h5 {
    text-align: left;
  }
  p {
    min-height: auto;
    text-align: left;
    margin: 25px 0;
  }
}
.lockdown-chart {
  margin: 0 0 30px 20px;
}
</style>
